<template>
    <div class="view-modal-body">
        <ul class="header">
			<li
				v-for="item in urlMaps"
				:key="item.url"
                v-show='item.show'
				@click="componentSwitch(item.url)"
				:class="{ active : active === item.url }"
			>{{item.name}}</li>
			<span @click="closeModal"><i class="el-icon-close"/></span>
		</ul>
		<div class="container">
			<Modify ref="modifyModel" @close='close' :id='id' :AuthorityList='AuthorityList' :modifyData='modifyData' :isAdd='isAdd' :addDisable='addDisable' :isDisabled='isDisabled' @getId='getId' v-if="active === urlMaps[0].url"/>
			<Bind :isShow='showBind' :id='id' :isAdd='isAdd' :modifyData='modifyData' :isDisabled='isDisabled' v-if="active === urlMaps[1].url"/>
		</div>
    </div>
</template>

<script>
import Modify from '@/components/personnelManage/Modify.vue'
import Bind from '@/components/personnelManage/Bind.vue'
export default {
	name: 'viewModal',
	components: {
		Modify,
		Bind
	},
	props: {
		modifyData: Object,
		isAdd: Boolean,
		isShow: Boolean,
		addDisable: Boolean,
		isDisabled: Boolean,
		AuthorityList: Object
	},
	data () {
		return {
			urlMaps: [
				{ name: '员工档案', url: 'Modify', show: true },
				{ name: '关联门店', url: 'Bind', show: false }
			],
			id: null,
			active: 'Modify',
			showBind: false
		}
	},
	watch: {
		modifyData: {
			handler (data) {
				console.log(data)
			},
			immediate: true
		},
		isAdd: {
			handler (val) {
				if (val) {
					this.urlMaps[1].show = false
				}
			},
			immediate: true
		},
		isShow: {
			handler (val) {
				console.log(val)
				if (val === false) {
					if (this.active === 'Modify') {
						this.$refs.modifyModel.resetForm('ruleForm')
						this.id = null
					}
				} else {
					this.active = 'Modify'
					if (this.isAdd === false) {
						if (this.modifyData.isAdmin === 1) {
							this.urlMaps[1].show = false
						} else {
							this.urlMaps[1].show = false
						}
					}
				}
			},
			immediate: true
		}
	},
	methods: {
		close (data) {
			if (data) {
				this.$emit('showModal', false)
			}
		},
		getId (data) {
			this.id = data
		},
		closeModal () {
			this.$emit('showModal', false)
		},
		componentSwitch (url) {
			if (url === 'Bind') {
				if (this.isAdd) {
					if (this.id === null) {
						this.$message.error('请先完善基本信息')
						return false
					}
				}
				this.showBind = true
			} else {
				this.showBind = false
			}
			this.active = url
		}
	}
}
</script>

<style lang="stylus" scoped>
.view-modal-body {
	display flex
	flex: 1
	flex-direction column
	.header {
		border-bottom: 1px solid #dce2fd;
		height:48px;
		line-height: 48px;
		font-size: 16px;
		box-sizing border-box
		li {
			margin-right 40px
			cursor pointer
			height: 100%
			box-sizing:border-box
			float left
			&.active {
				border-bottom: 3px solid var(--fx-primary-color);
				font-weight: bold
			}
		}
		span {
			cursor pointer
			float right
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 21px;
			font-weight: bold;
			margin-top 12px
			.el-icon-close{
				color:#fff
			}
		}
	}
	.container {
        margin-top:10px;
		height: 450px;
	}
}
</style>
